import Typography from "@mui/material/Typography";
import { ERROR_RESIZE_DIMENSION_INVALID } from "../../i18n/keysTranslations";

const suggestionButtonSx = {
  p: 0,
  border: "none",
  background: "none",
  font: "inherit",
  color: "inherit",
  textDecoration: "underline",
  cursor: "pointer",
  "&:hover": {
    color: "text.secondary",
  },
};

export const DimensionSuggestion = ({ value, onSelect }) => (
  <Typography
    component="button"
    type="button"
    variant="caption"
    onClick={() => onSelect(value)}
    sx={suggestionButtonSx}
  >
    {value}px
  </Typography>
);

export const DimensionFieldHint = ({ validation, t }) => {
  if (!validation || validation.valid || validation.reason === "empty") {
    return null;
  }

  if (validation.reason === "invalid") {
    return (
      <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
        {t(ERROR_RESIZE_DIMENSION_INVALID)}
      </Typography>
    );
  }

  return null;
};
